// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 分页查询租户列表 GET /api/v1/hq/tenants */
export async function TenantControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.TenantControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputTenantListItemDtoArray>(
    "/api/v1/hq/tenants",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 创建租户 POST /api/v1/hq/tenants */
export async function TenantControllerCreateV1(
  body: MyApi.CreateTenantDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputTenantDto>("/api/v1/hq/tenants", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 查询租户详情 GET /api/v1/hq/tenants/${param0} */
export async function TenantControllerDetailV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.TenantControllerDetailV1Params,
  options?: { [key: string]: any }
) {
  const { code: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputTenantDto>(
    `/api/v1/hq/tenants/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 更新租户 PATCH /api/v1/hq/tenants/${param0} */
export async function TenantControllerUpdateV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.TenantControllerUpdateV1Params,
  body: MyApi.UpdateTenantDto,
  options?: { [key: string]: any }
) {
  const { code: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputTenantDto>(
    `/api/v1/hq/tenants/${param0}`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 创建会员认证 POST /api/v1/hq/tenants/${param0}/allinpayqd-member-create */
export async function TenantControllerCreateAllinpayqdMemberV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.TenantControllerCreateAllinpayqdMemberV1Params,
  options?: { [key: string]: any }
) {
  const { code: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputApplyCertificationResultDto>(
    `/api/v1/hq/tenants/${param0}/allinpayqd-member-create`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 同步会员认证结果 POST /api/v1/hq/tenants/${param0}/allinpayqd-member-sync */
export async function TenantControllerSyncAllinpayqdMemberV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.TenantControllerSyncAllinpayqdMemberV1Params,
  options?: { [key: string]: any }
) {
  const { code: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(
    `/api/v1/hq/tenants/${param0}/allinpayqd-member-sync`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 中金支付影印件采集（4600） POST /api/v1/hq/tenants/${param0}/cpcnpay-collect-image */
export async function TenantControllerCollectCpcnImageV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.TenantControllerCollectCpcnImageV1Params,
  options?: { [key: string]: any }
) {
  const { code: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputCpcnpayCollectImageDto>(
    `/api/v1/hq/tenants/${param0}/cpcnpay-collect-image`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 中金支付企业开户（4601） POST /api/v1/hq/tenants/${param0}/cpcnpay-open-account */
export async function TenantControllerOpenCpcnAccountV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.TenantControllerOpenCpcnAccountV1Params,
  body: MyApi.OpenCpcnpayAccountDto,
  options?: { [key: string]: any }
) {
  const { code: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputCpcnpayOpenAccountDto>(
    `/api/v1/hq/tenants/${param0}/cpcnpay-open-account`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 中金支付开户状态查询（4616） POST /api/v1/hq/tenants/${param0}/cpcnpay-query-account */
export async function TenantControllerQueryCpcnAccountV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.TenantControllerQueryCpcnAccountV1Params,
  options?: { [key: string]: any }
) {
  const { code: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputCpcnpayQueryAccountDto>(
    `/api/v1/hq/tenants/${param0}/cpcnpay-query-account`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 冻结租户 POST /api/v1/hq/tenants/${param0}/freeze */
export async function TenantControllerFreezeV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.TenantControllerFreezeV1Params,
  options?: { [key: string]: any }
) {
  const { code: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputTenantDto>(
    `/api/v1/hq/tenants/${param0}/freeze`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 发起赋强信息录入 POST /api/v1/hq/tenants/${param0}/notary-create */
export async function TenantControllerCreateNotaryV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.TenantControllerCreateNotaryV1Params,
  options?: { [key: string]: any }
) {
  const { code: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(
    `/api/v1/hq/tenants/${param0}/notary-create`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 终止租户（必须指定承接方） POST /api/v1/hq/tenants/${param0}/terminate */
export async function TenantControllerTerminateV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.TenantControllerTerminateV1Params,
  body: MyApi.TerminateTenantDto,
  options?: { [key: string]: any }
) {
  const { code: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputTenantDto>(
    `/api/v1/hq/tenants/${param0}/terminate`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 解冻租户 POST /api/v1/hq/tenants/${param0}/unfreeze */
export async function TenantControllerUnfreezeV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.TenantControllerUnfreezeV1Params,
  options?: { [key: string]: any }
) {
  const { code: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputTenantDto>(
    `/api/v1/hq/tenants/${param0}/unfreeze`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}
